import { Mail, Phone, BookOpen, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { BRAND } from "../data/content";

export const StickyMobileCTA = () => {
  return (
    <div
      data-testid="sticky-mobile-cta"
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 px-3 pb-3 pt-2 bg-gradient-to-t from-white via-white/95 to-white/0 backdrop-blur-md"
    >
      <div className="grid grid-cols-4 gap-1.5 rounded-2xl bg-white/95 border border-black/5 p-1.5 shadow-[0_-12px_40px_-20px_rgba(17,17,17,0.4)]">
        <a
          href={`mailto:${BRAND.email}`}
          data-testid="sticky-mobile-contact"
          aria-label="Email Fresh Fast Foods"
          className="inline-flex flex-col items-center justify-center gap-0.5 rounded-xl border border-brand-charcoal/15 text-brand-charcoal py-2 hover:bg-brand-cream transition-colors"
        >
          <Mail className="h-4 w-4" />
          <span className="text-[9px] font-bold uppercase tracking-wider">Contact</span>
        </a>
        <a
          href={`tel:${BRAND.phoneTel}`}
          data-testid="sticky-mobile-call"
          aria-label="Call Fresh Fast Foods"
          className="inline-flex flex-col items-center justify-center gap-0.5 rounded-xl border-2 border-brand-charcoal text-brand-charcoal py-2 hover:bg-brand-charcoal hover:text-white transition-colors"
        >
          <Phone className="h-4 w-4" />
          <span className="text-[9px] font-bold uppercase tracking-wider">Call</span>
        </a>
        <Link
          to="/menu"
          data-testid="sticky-mobile-menu"
          aria-label="View menu"
          className="inline-flex flex-col items-center justify-center gap-0.5 rounded-xl bg-brand-charcoal text-brand-gold py-2 hover:bg-brand-gold hover:text-brand-charcoal transition-colors"
        >
          <BookOpen className="h-4 w-4" />
          <span className="text-[9px] font-bold uppercase tracking-wider">Menu</span>
        </Link>
        <Link
          to="/quote"
          data-testid="sticky-mobile-quote"
          aria-label="Request a catering quote"
          className="inline-flex flex-col items-center justify-center gap-0.5 rounded-xl bg-brand-teal text-white py-2 hover:bg-brand-teal-dark transition-colors shadow-[0_8px_20px_-8px_rgba(0,166,178,0.7)]"
        >
          <ArrowRight className="h-4 w-4" />
          <span className="text-[9px] font-bold uppercase tracking-wider">Quote</span>
        </Link>
      </div>
    </div>
  );
};

export default StickyMobileCTA;
